import { useState } from 'react';

import { Button } from "react-bootstrap";

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UsersDashboardCards from '../../components/admin/users/UsersDashboardCards.jsx';
import UserModal from '../../components/admin/users/UserModal.jsx';
import UsersTable from '../../components/admin/users/UsersTable.jsx';
import { licenses } from "./data.js";

function UsersPage(props) {
    const [showModal, setShowModal] = useState(false)

    return <>
        <div className="container">
            <div className="d-flex justify-content-between mb-4">

                <h3 style={{ color: '#fff' }}>Gerenciamento de Usuários</h3>

                <Button onClick={() => setShowModal(true)}>
                    <FontAwesomeIcon icon={faPlus} /> Novo Usuário
                </Button>

            </div>
            <UsersDashboardCards />
            <UsersTable users={licenses} />
            <UserModal
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </div>
    </>
}

export default UsersPage;